import './post-navigation/index';
document.addEventListener( 'DOMContentLoaded', () => {
	const postNavigation = document.querySelector( '.masthead-lower__article' );
	const mediaQuery = window.matchMedia( '(max-width: 440px)' );
	const jumpSection = document.querySelector( '.entry-meta__jump' );
	const showThreshold = jumpSection ? jumpSection.offsetTop + jumpSection.offsetHeight : 100;

	const togglePostNavigation = () => {
		if ( ! postNavigation ) {
			return;
		}

		if ( ! mediaQuery.matches ) {
			postNavigation.classList.add( 'hidden' );
			return;
		}

		if ( window.scrollY > showThreshold ) {
			if ( ! postNavigation.classList.contains( 'slide-in' ) ) {
				postNavigation.classList.remove( 'hidden' );
				postNavigation.classList.remove( 'slide-out' );
				postNavigation.classList.add( 'slide-in' );
			}
		} else {
			if ( ! postNavigation.classList.contains( 'slide-out' ) ) {
				postNavigation.classList.remove( 'slide-in' );
				postNavigation.classList.add( 'slide-out' );
			}
		}

		postNavigation.addEventListener( 'transitionend', () => {
			if (postNavigation.classList.contains( 'slide-out' ) ) {
				postNavigation.classList.add( 'hidden' );
			}
		} );
	};

	// Initial check in case the user is already scrolled down
	togglePostNavigation();

	// Add scroll event listener
	window.addEventListener( 'scroll', togglePostNavigation );
} );
